import type { VFC } from 'react'
import { Button, ButtonSize, Icon } from '@opallabs/lapidary'
import * as styles from './styles'

export type ReviewActionsProps = {
  onAccept: () => void
  onReject: () => void
}

export const ReviewActions: VFC<ReviewActionsProps> = ({
  onAccept,
  onReject,
}) => (
  <div css={styles.container}>
    <Button
      css={styles.acceptButton}
      icon={<Icon glyph="gem-check" height={8} width={8} ariaHidden />}
      name="Accept suggestion"
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        onAccept()
      }}
      size={ButtonSize.Small}
      variant="primaryGem"
    />
    <Button
      css={styles.rejectButton}
      icon={<Icon glyph="gem-close" height={8} width={8} ariaHidden />}
      name="Reject suggestion"
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        onReject()
      }}
      size={ButtonSize.Small}
      variant="ghostGem"
    />
  </div>
)
